/**
 * Inlines the icon sprite into the document.
 *
 * Mounted once, near the root. `<use href="#i-name">` resolves against the
 * current document, so the symbols must be present in the DOM — referencing an
 * external file works in some browsers and silently renders nothing in others,
 * and the failure is an invisible icon rather than an error.
 *
 * Imported with Vite's `?raw` so the SVG ships inside the JS bundle: a
 * separate request for it would leave every icon blank until it landed.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 5.4
 */
import spriteMarkup from '../../assets/icons/sprite.svg?raw';

export function IconSprite(): React.JSX.Element {
  return (
    <div
      /* Hidden from assistive technology and from layout: this element only
         carries symbol definitions, which are never drawn where they sit. */
      aria-hidden="true"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      /* The markup is a build-time import of a file in this repository, not
         user input — there is no injection surface here. */
      dangerouslySetInnerHTML={{ __html: spriteMarkup }}
    />
  );
}
